
import { common } from '@tencent/ceiba-base-components';

const camelize = str => str.replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : ''));
function getPluginName(ast, name) {
  return `$${name}${camelize(`-${ast}`)}Plugin`;
}
const openUrl = (url, target = '_self') => {
  try {
    if (window.Tgclub &&  window.Tgclub.openNewPage && url.indexOf('tgclub://') === -1) {
      if (url.indexOf('tgc://') > -1) {
        // 跳转闪现 app 特殊处理
        window.Tgclub.openExtendUr(url);
      } else {
        window.Tgclub.openNewPage(url);
      }
      return;
    }
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      window.location.href = url;
      return;
    }
    const newTab = window.open('', target);
    newTab.opener = null;
    newTab.location = url;
  } catch (error) {
    console.error('openUrl fail, err=', error);
    window.location.href = url;
  }
};

const openerPlugin = {
  install(Vue) {
    Vue.prototype.$opener = {
      getOpenViewSchema: async (params) => {
        if (Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'opener')] && Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'opener')].getOpenViewSchema) {
          return await Vue.prototype[getPluginName(Vue.prototype.$actInfo.ast, 'opener')].getOpenViewSchema(params);
        }
        return;
      },
      openView: async (params) => {
        // todo 迁移登录态逻辑配置到这里
        const passThroughParamsStr = params.paramStr;
        // 处理自定义透传参数的问题
        const paramsArray = passThroughParamsStr?.split('|') ?? [];
        let targetUrl = params.url;
        targetUrl = common.tool.passThroughUrlParam(targetUrl, paramsArray);
        openUrl(targetUrl, params.target);
      },
    };
  },
};

export default openerPlugin;
